
import NumberInput from '@components/new-styleguide/form/NumberInput.vue';
import TooltipElement from '@components/new-styleguide/TooltipElement.vue';
import { InformationDetail } from '@components/settings/information/InformationLines.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconOeamtcClose from '@components/icons/icon-oeamtc-close.svg';
import IconCheck from '@components/icons/icon-check.svg';
import IconEdit from '@components/icons/icon-edit.svg';

@Component({
  name: 'InformationLine',
  components: {
    NumberInput,
    TooltipElement,
    IconOeamtcClose,
    IconCheck,
    IconEdit
  }
})
export default class InformationLine extends Vue {
  @Prop({ required: true })
  private info: InformationDetail;

  @Prop({ required: true })
  private editMode: boolean;

  @Prop({ default: false })
  private disabled: boolean;
}
